import { render } from "./PanelsPage.vue?vue&type=template&id=2ed0e6eb"
import script from "./PanelsPage.vue?vue&type=script&lang=js"
export * from "./PanelsPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__